import React, { useContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import HelloWorldUI from './HelloWorldUI';
import LoginContext from '../../contexts/LoginContext';

export default function HelloWorld({
  withEmoji,
}: {
  withEmoji?: boolean;
}): JSX.Element {
  const { isLoggedIn, userProfile } = useContext(LoginContext);
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    /* eslint-disable no-console */
    console.log('isLoggedIn:', isLoggedIn);
    console.log('userProfile:', userProfile);

    if (isLoggedIn) {
      setName(userProfile?.given_name || null);
    } else {
      setName(null);
    }

    console.log('name:', name);
    /* eslint-enable no-console */
  }, [isLoggedIn, userProfile]);

  return <HelloWorldUI name={name} withEmoji={withEmoji} />;
}

HelloWorld.defaultProps = {
  withEmoji: false,
};

HelloWorld.propTypes = {
  withEmoji: PropTypes.bool,
};

HelloWorld.attributes = {
  withEmoji: {
    type: 'boolean',
  },
};
